import { ACTIVITY_TOOL_REPEAT_MS, toolForPath, type ActivityTool } from '~/utils/activity/tools';
import { stripLocalePrefix } from '~/utils/i18n/locale';

// Last time each tool was logged in this tab. Module-level so the page tracker and the Ask
// launcher share it, and so moving around inside one tool counts as a single open.
const lastLoggedAt = new Map<ActivityTool, number>();

// Logs portal tool opens for the admin Activity page. Best-effort: never throws, never blocks.
export const useActivityTracking = () => {
  const authStore = useAuthStore();

  const trackTool = (tool: ActivityTool, path?: string) => {
    if (!authStore.token || authStore.getIsImpersonating) return;
    const now = Date.now();
    const last = lastLoggedAt.get(tool);
    if (last !== undefined && now - last < ACTIVITY_TOOL_REPEAT_MS) return;
    lastLoggedAt.set(tool, now);

    // Same event in PostHog (when enabled) so tool usage can be queried there too.
    useNuxtApp().$posthog?.capture('tool_opened', { tool, path });

    $fetch('/api/activity/tool', {
      method: 'POST',
      headers: { Authorization: `Bearer ${authStore.token}` },
      body: { tool, path },
    }).catch(() => {
      // Analytics only — a failed write must never surface to the agent.
    });
  };

  const trackPath = (rawPath: string) => {
    const path = stripLocalePrefix(rawPath);
    const tool = toolForPath(path);
    if (tool) trackTool(tool, path);
  };

  return {
    trackTool,
    trackPath,
  };
};
